
<div mat-dialog-content>
  <p>Ce site utilise des cookies pour vous offrir le meilleur service. En poursuivant votre navigation, vous acceptez l'utilisation des cookies. <a href="https://www.clem-e.com/mentions-legales" target="_blank">En savoir plus</a></p>
</div>
<div mat-dialog-actions class="row justify-content-center">
  <button class="" mat-button color=""(click)="OkData();">Strictement nécessaires uniquement</button>
  <button class="col-5" mat-button (click)="OkData();">Tout accepter</button>
</div>
<!-- "ngx-cookie-service": "^2.3.0", -->